export default function cliPrint(message) {
  console.log(message);
}
